import { render, staticRenderFns } from "./NoticeInfo.vue?vue&type=template&id=4a6578f0&scoped=true&lang=html"
import script from "./NoticeInfo.vue?vue&type=script&lang=js"
export * from "./NoticeInfo.vue?vue&type=script&lang=js"
import style0 from "./NoticeInfo.vue?vue&type=style&index=0&id=4a6578f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6578f0",
  null
  
)

export default component.exports